import React from 'react'
import Dbnav from '../Dbnav'

const DBOrders = () => {
  return (
   <>
   <Dbnav/>
   <section id="hero">
                 <div className="hero-container">
                     <div className="hero-logo">
                         <h1 className="font-weight-bold">Orders to delivery</h1>
                     </div>
                 </div>
            </section>
            <section className="">
                <div className="container">
                    <div className="cart">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="thead-dark tableH">
                                    <tr >
                                        <th scope="col" className="text-white ">Order Number</th>
                                        <th scope="col" className="text-white ">Date</th>
                                        <th scope="col" className="text-white ">Total Amount</th>
                                        <th scope="col" className="text-white ">Total Discount</th>
                                        <th scope="col" className="text-white ">Delivery Address</th>
                                        <th scope="col" className="text-white ">Payment Method</th>
                                        <th scope="col" className="text-white ">Payment Status</th>
                                        <th scope="col" className="text-white ">Delivery Status</th>
                                    </tr>
                                </thead>
                                {/* <tbody>
                                 {orders ? orders.map((data) => (
                                    <>
                                    <tr className='orderslist target' onClick={()=>ordersummary(data.orderNumber)}>
                                        <td className="productId">{data.orderNumber}</td>
                                        <td className='quantity'>{data.date.substring(5,16)}</td>
                                        <td className="total">{data.totalAmount}</td>
                                        <td className="total">{data.totalDiscount}</td>
                                        <td className="total">{data.address}</td>
                                        <td className="total">{data.payment}</td>
                                        <td className="pay">{data.isBilled === true?<>Paid</>:<>Unpaid</>}</td>
                                        <td className="delivery">{data.isBilled === true?<>Delivered</>:<>Not Delivered</>}</td>
                                    </tr>
                                    </>
                                     )) : <></>} 
                                </tbody> */}
                            </table>
                        </div>
                    </div>
                </div>
                </section>
    </>
  )
}

export default DBOrders